const normalizePathname = (value) => {
  const rawPath = String(value || '').trim();

  if (!rawPath || rawPath === '/') {
    return '/';
  }

  return rawPath.replace(/\/+$/, '');
};

export default normalizePathname;
